import { DirectoryAddressSearchDto } from "@/ContactDirectory/Api/medfar-contactdirectory/dist";

export class DirectoryAddress {
    public id: string;
    public streetAddress: string;
    public city: string;
    public postalCode: string;
    public countryId: string;
    public stateId: string;

    public constructor(init?: Partial<DirectoryAddress>) {
        Object.assign(this, init);
    }

    public toString(): string {
        const country = cacheStore.CountryCache.firstOrDefault(p => p.Id === this.countryId);
        const state = cacheStore.StateCache.firstOrDefault(p => p.Id === this.stateId);

        return [
            this.streetAddress,
            this.city,
            state?.Name,
            country?.Name,
            this.postalCode
        ].filter(p => p).join(", ");
    }

    public static fromSearchDto(dto: DirectoryAddressSearchDto): DirectoryAddress {
        return new DirectoryAddress(dto);
    }
}
